import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import CompanyHeader from './components/CompanyHeader';
import CompanyHero from './components/CompanyHero';
import CompanyFooter from './components/CompanyFooter';
import BulkLeadsCaller from './pages/BulkLeadsCaller';
import PrivacyPolicy from './pages/PrivacyPolicy';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/bulk-leads-caller" element={<BulkLeadsCaller />} />
          <Route path="/" element={
            <>
              <CompanyHeader />
              <CompanyHero />
              <CompanyFooter />
            </>
          } />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
